import React, { useState, useEffect, useRef, useMemo, useCallback } from 'react';
import './ProductInfo.css';
import 'number-flow';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import NavInf from '../../components/NavInf/NavInf';
import { useParams } from 'react-router-dom';
import ProductWrapper from '../../components/Product/ProductWrapper';
import Alert from '../../components/Alert/Alert';
import Loader from '../../components/Loader/Loader';
import { secureFetch } from '../../utils/secureFetch';
import ShareButton from '../../components/ShareButton/ShareButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faShoppingCart } from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { openProductWhatsApp } from '../../utils/whatsappHelper';
import Masonry from 'react-masonry-css';
import { analytics } from '../../config/firebase';
import { logEvent } from 'firebase/analytics';
import { redirectToLogin } from '../../utils/navigationHelper';

const ProductInfo = ({ productInfo, isOrder = false, onAddToOrder }) => {

  const mainImageRef = useRef(null);
  const animatedPriceRef = useRef(null);
  const [hasItems, setHasItems] = useState(false);
  
  // Ref para scroll infinito
  const scrollObserverRef = useRef(null);

  useEffect(() => {
    const checkCart = () => {
      try {
        const cart = JSON.parse(localStorage.getItem('carritoPrivado')) || [];
        setHasItems(cart.length > 0);
      } catch (error) {
        setHasItems(false);
      }
    };

    checkCart();

    // Escuchar cambios manuales al carrito (evento personalizado)
    window.addEventListener('cartPrivadoChanged', checkCart);

    return () => {
      window.removeEventListener('cartPrivadoChanged', checkCart);
    };
  }, []);

  const [selectedColor, setSelectedColor] = useState('');
  const [selectedSize, setSelectedSize] = useState('');

  const handleAddToOrder = () => {
    if (colors.length > 0 && !selectedColor) {
      setAlert({ type: 'error', message: 'Selecciona un color' });
      return false;
    }

    if (sizes.length > 0 && !selectedSize) {
      setAlert({ type: 'error', message: 'Selecciona una talla' });
      return false;
    }

    if (!applicablePrice) {
      setAlert({ type: 'error', message: 'No hay precio válido para esta cantidad' });
      return false;
    }

    const snapshot = {
      productId: product.id,
      nombre: product.name,
      talla: selectedSize || null,
      color: selectedColor || null,
      cantidad: quantity,
      precio: applicablePrice.price,
      productPrices: prices,
      image: mainImage,
    };

    if (onAddToOrder) {
      onAddToOrder(snapshot);
      setAlert({ type: 'info', message: 'Producto añadido a la orden' });
      return true; // ✅ validación completa
    }

    return false;
  };

  const handleWhatsAppContact = async () => {
    try {
      
      if (!provider.telefono && !provider.phone) {
        setAlert({ type: 'error', message: 'Este proveedor no tiene WhatsApp disponible' });
        return;
      }

      // 📊 Track WhatsApp click en Google Analytics
      if (analytics) {
        const phoneNumber = provider.telefono || provider.phone;
        
        logEvent(analytics, 'whatsapp_click', {
          provider_phone: phoneNumber,
          provider_name: provider.nombre_empresa,
          provider_id: provider.id,
          product_id: product.id,
          product_name: product.name,
          selected_color: selectedColor || 'ninguno',
          selected_size: selectedSize || 'ninguno',
          quantity: quantity,
          price: applicablePrice?.price || 0,
          total_value: (quantity * (applicablePrice?.price || 0)),
          currency: 'COP'
        });
      }

      await openProductWhatsApp(
        product, 
        provider, 
        selectedColor, 
        selectedSize, 
        quantity, 
        applicablePrice.price,
        mainImage
      );

      // Limpiar el mensaje de carga
      setAlert(null);
    } catch (error) {
      console.error('❌ Error al abrir WhatsApp:', error);
      setAlert({ type: 'error', message: error.message });
    }
  };


  const [alert, setAlert] = useState(null);
  const { uuid } = useParams();
  const id = productInfo?.uuid || uuid;
  const [product, setProduct] = useState(null);
  const [images, setImages] = useState([]);
  const [prices, setPrices] = useState([]);
  const [provider, setProvider] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const [colors, setColors] = useState([]);
  const [sizes, setSizes] = useState([]);
  const [mainImage, setMainImage] = useState(null);
  const [relatedProducts, setRelatedProducts] = useState([]);
  const [categories, setCategories] = useState([]); // Categorías o subcategorías
  const [categoryType, setCategoryType] = useState(''); // 'categories' o 'subcategories'
  const [selectedCategory, setSelectedCategory] = useState(null); // Slug de categoría seleccionada
  const [productSeed] = useState(() => Math.random().toString(36).substring(2)); // Seed para orden aleatorio
  const [productCursor, setProductCursor] = useState(null); // Cursor para paginación
  const [hasMoreProducts, setHasMoreProducts] = useState(true);
  const [loadingProducts, setLoadingProducts] = useState(false);
  const quantityRef = useRef(null);
  const [imgLoaded, setImgLoaded] = useState(false);
  const [imageHeight, setImageHeight] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const usuario = JSON.parse(localStorage.getItem('usuario'));
  const userEmpresa = usuario?.proveedorInfo?.nombre_empresa;
  const isOwnProduct = userEmpresa && provider?.nombre_empresa && userEmpresa === provider.nombre_empresa;
  const isIframe = window.location.search.includes('privado=true');

  // Configuración de breakpoints para Masonry
  const breakpointColumnsObj = {
    default: 6,
    1600: 6,
    1200: 5,
    768: 3,
    480: 2
  };

  // Ordenar tallas antes de setear
  const sortSizes = (sizesRaw) => {
    const priority = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL'];

    return sizesRaw.slice().sort((a, b) => {
      const aVal = a.name.toUpperCase();
      const bVal = b.name.toUpperCase();

      const aIndex = priority.indexOf(aVal);
      const bIndex = priority.indexOf(bVal);

      const isANumeric = !isNaN(Number(aVal));
      const isBNumeric = !isNaN(Number(bVal));

      if (isANumeric && isBNumeric) {
        return Number(aVal) - Number(bVal);
      }

      if (!isANumeric && !isBNumeric) {
        if (aIndex !== -1 && bIndex !== -1) {
          return aIndex - bIndex;
        }
        return aVal.localeCompare(bVal);
      }

      // Poner primero letras y luego números, o viceversa si prefieres
      return isANumeric ? 1 : -1;
    });
  };

  // Efecto para manejar la animación de altura de imagen - OPTIMIZADO
  useEffect(() => {
    const imageElement = mainImageRef.current;
    if (!imageElement) return;

    const handleImageLoad = () => {
      const newHeight = imageElement.offsetHeight;
      
      if (imageHeight > 0 && Math.abs(newHeight - imageHeight) > 10) {
        // 🔧 OPTIMIZACIÓN: Usar requestAnimationFrame para suavizar cambios
        requestAnimationFrame(() => {
          setIsTransitioning(true);
          setImageHeight(newHeight);
          
          // Reducir tiempo de transición para menos impacto
          setTimeout(() => setIsTransitioning(false), 150); // Era 300ms
        });
      } else {
        setImageHeight(newHeight);
      }
    };

    // 🔧 OPTIMIZACIÓN: ResizeObserver con throttling para reducir eventos
    let resizeTimeout;
    const resizeObserver = new ResizeObserver((entries) => {
      // Throttle resize events para evitar spam
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        handleImageLoad();
      }, 50); // 50ms throttle
    });

    if (imageElement.complete) {
      handleImageLoad();
    }

    imageElement.addEventListener('load', handleImageLoad);
    resizeObserver.observe(imageElement);

    return () => {
      imageElement.removeEventListener('load', handleImageLoad);
      resizeObserver.disconnect();
      clearTimeout(resizeTimeout);
    };
  }, [mainImage, imageHeight]);

  useEffect(() => {
    // Funcionalidad de arrastre optimizada para máxima fluidez
    if (!imgLoaded || images.length <= 1) return;
    
    let startX = 0;
    let currentX = 0;
    let isMoving = false;
    let isDragging = false;
    let touchStartY = 0;
    
    const handleTouchStart = (e) => {
      startX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      currentX = startX;
      isMoving = false;
      isDragging = false;
    };
    
    const handleTouchMove = (e) => {
      currentX = e.touches[0].clientX;
      const diff = currentX - startX;
      
      // 🔧 OPTIMIZACIÓN: Solo prevenir default si realmente necesitamos controlar el drag
      // Esto reduce la interferencia con el scroll nativo
      if (Math.abs(diff) > 10 && !isDragging) { // Threshold más alto
        
        // 🔧 Verificar si el movimiento es más horizontal que vertical
        const startY = e.touches[0].clientY;
        const currentY = e.touches[0].clientY;
        const verticalDiff = Math.abs(currentY - (touchStartY || startY));
        const horizontalDiff = Math.abs(diff);
        
        // Solo prevenir si es claramente un swipe horizontal
        if (horizontalDiff > verticalDiff * 1.5) {
          isDragging = true;
          isMoving = true;
          e.preventDefault(); // ⚠️ Solo prevenir cuando es claramente horizontal
        } else {
          // 🔧 Es un scroll vertical, no interferir
          return; // Salir sin hacer nada
        }
      }
      
      if (isDragging) {
        const imageElement = mainImageRef.current;
        if (imageElement) {
          // Respuesta instantánea sin límites para mejor feeling
          imageElement.style.transform = `translateX(${diff}px)`;
          
          let previewElement = imageElement.parentNode.querySelector('.preview-image');
          
          if (!previewElement) {
            previewElement = document.createElement('img');
            previewElement.className = 'preview-image';
            previewElement.style.cssText = `
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              object-fit: cover;
              z-index: 1;
              pointer-events: none;
            `;
            imageElement.parentNode.appendChild(previewElement);
          }
          
          const currentIndex = images.findIndex(img => img.imageUrl === mainImage);
          let previewIndex;
          
          if (diff > 0) {
            previewIndex = currentIndex > 0 ? currentIndex - 1 : images.length - 1;
            previewElement.style.transform = `translateX(${diff - window.innerWidth}px)`;
          } else {
            previewIndex = currentIndex < images.length - 1 ? currentIndex + 1 : 0;
            previewElement.style.transform = `translateX(${diff + window.innerWidth}px)`;
          }
          
          previewElement.src = images[previewIndex].imageUrl;
          // Opacity más progresiva para mejor feedback visual
          previewElement.style.opacity = Math.min(1, Math.abs(diff) / 60);
        }
      }
    };
    
    const handleTouchEnd = (e) => {
      const imageElement = mainImageRef.current;
      const previewElement = imageElement?.parentNode.querySelector('.preview-image');
      
      if (!isMoving) {
        if (previewElement) previewElement.remove();
        return;
      }
      
      const endX = e.changedTouches[0].clientX;
      const diff = startX - endX;
      const threshold = 50; // Threshold más bajo para swipes más fáciles
      
      if (Math.abs(diff) > threshold) {
        const currentIndex = images.findIndex(img => img.imageUrl === mainImage);
        let newIndex;
        
        if (diff > 0) {
          newIndex = currentIndex < images.length - 1 ? currentIndex + 1 : 0;
        } else {
          newIndex = currentIndex > 0 ? currentIndex - 1 : images.length - 1;
        }
        
        if (imageElement && previewElement) {
          // Transición súper rápida para feeling snappy
          imageElement.style.transition = 'transform 0.12s cubic-bezier(0.4, 0.0, 0.2, 1)';
          previewElement.style.transition = 'transform 0.12s cubic-bezier(0.4, 0.0, 0.2, 1), opacity 0.12s ease';
          
          const exitDirection = diff > 0 ? '-100%' : '100%';
          
          imageElement.style.transform = `translateX(${exitDirection})`;
          previewElement.style.transform = 'translateX(0)';
          previewElement.style.opacity = '1';
          
          setTimeout(() => {
            setMainImage(images[newIndex].imageUrl);
            if (previewElement) previewElement.remove();
            imageElement.style.transition = '';
            imageElement.style.transform = '';
          }, 120);
        }
      } else {
        // Return súper rápido si no hay cambio
        if (imageElement) {
          imageElement.style.transition = 'transform 0.1s cubic-bezier(0.4, 0.0, 0.2, 1)';
          imageElement.style.transform = '';
          
          if (previewElement) {
            previewElement.style.transition = 'opacity 0.1s ease';
            previewElement.style.opacity = '0';
            setTimeout(() => {
              if (previewElement) previewElement.remove();
            }, 100);
          }
          
          setTimeout(() => {
            imageElement.style.transition = '';
          }, 100);
        }
      }
      
      isDragging = false;
    };
    
    const imageElement = mainImageRef.current;
    if (imageElement) {
      // ⚠️ ESTOS EVENT LISTENERS PUEDEN INTERFERIR CON EL SCROLL
      imageElement.addEventListener('touchstart', handleTouchStart, { passive: true });
      imageElement.addEventListener('touchmove', handleTouchMove, { 
        passive: false, // ❌ Este es POSIBLEMENTE el problema principal
        capture: true   // 🔧 Intentar capturar antes que el scroll
      }); 
      imageElement.addEventListener('touchend', handleTouchEnd, { passive: true });
      
      return () => {
        imageElement.removeEventListener('touchstart', handleTouchStart);
        imageElement.removeEventListener('touchmove', handleTouchMove);
        imageElement.removeEventListener('touchend', handleTouchEnd);
        
        // Limpiar cualquier imagen de preview que quede
        const previewElement = imageElement.parentNode?.querySelector('.preview-image');
        if (previewElement) {
          previewElement.remove();
        }
      };
    }
  }, [imgLoaded, images, mainImage]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const productRes = await fetch(`https://api.minymol.com/products/${id}`);
        const productData = await productRes.json();
        setProduct(productData);
        setColors(productData.colors || []);
        setSizes(sortSizes(productData.sizes || []));

        const imagesRes = await fetch(`https://api.minymol.com/images/by-product/${id}`);
        const imagesData = await imagesRes.json();
        setImages(imagesData);
        setMainImage(imagesData?.[0]?.imageUrl || null);

        const pricesRes = await fetch(`https://api.minymol.com/product-prices/product/${id}`);
        const pricesData = await pricesRes.json();
        setPrices(pricesData);

        const firstQty = pricesData?.[0]?.quantity?.split(',')?.[0];
        if (firstQty) setQuantity(parseInt(firstQty.trim()));

        const providerRes = await fetch(`https://api.minymol.com/providers/public/${productData.providerId}`);
        const providerData = await providerRes.json();
        setProvider(providerData);

        // Cargar categorías/subcategorías del proveedor
        const categoriesRes = await fetch(`https://api.minymol.com/providers/${productData.providerId}/categories-or-subcategories`);
        const categoriesData = await categoriesRes.json();
        setCategories(categoriesData.items || []);
        setCategoryType(categoriesData.type || '');

        // Cargar primeros productos del proveedor
        await loadProviderProducts(productData.providerId, null, true);

      } catch (err) {
        console.error('Error al cargar datos del producto:', err);
      }
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  // Función para cargar productos del proveedor con paginación
  const loadProviderProducts = useCallback(async (providerId, categorySlug = null, reset = false) => {
    if (loadingProducts) return;
    
    setLoadingProducts(true);

    try {
      const params = new URLSearchParams({
        limit: '20',
        seed: productSeed,
      });

      if (categorySlug) {
        if (categoryType === 'categories') {
          params.append('categorySlug', categorySlug);
        } else {
          params.append('subCategorySlug', categorySlug);
        }
      }

      if (!reset && productCursor) {
        params.append('cursor', productCursor);
      }

      const productsRes = await fetch(`https://api.minymol.com/providers/${providerId}/products?${params.toString()}`);
      const productsData = await productsRes.json();

      if (reset) {
        setRelatedProducts(productsData.products || []);
      } else {
        setRelatedProducts(prev => [...prev, ...(productsData.products || [])]);
      }

      setProductCursor(productsData.nextCursor);
      setHasMoreProducts(productsData.hasMore);
    } catch (err) {
      console.error('Error al cargar productos del proveedor:', err);
    } finally {
      setLoadingProducts(false);
    }
  }, [loadingProducts, productSeed, categoryType, productCursor]);

  // Efecto para cargar más productos cuando cambia la categoría seleccionada
  useEffect(() => {
    if (provider) {
      setProductCursor(null);
      setHasMoreProducts(true);
      loadProviderProducts(provider.id, selectedCategory, true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCategory, provider]);

  const availableQuantities = useMemo(() => {
    const set = new Set();
    prices.forEach(p => {
      p.quantity.split(',').forEach(q => set.add(parseInt(q.trim())));
    });
    const result = Array.from(set).sort((a, b) => a - b);
    return result;
  }, [prices]);

  const applicablePrice = useMemo(() => {
    const result = prices.find(p => {
      const qList = p.quantity.split(',').map(q => parseInt(q.trim()));
      return qList.includes(quantity);
    });
    return result;
  }, [quantity, prices]);

  const handleAddToCart = async () => {
    if (colors.length > 0 && !selectedColor) {
      setAlert({ type: 'error', message: 'Selecciona un color' });
      return;
    }

    if (sizes.length > 0 && !selectedSize) {
      setAlert({ type: 'error', message: 'Selecciona una talla' });
      return;
    }

    if (!applicablePrice) {
      setAlert({ type: 'error', message: 'No hay precio válido para esta cantidad' });
      return;
    }

    const item = {
      productId: product.id,
      nombre: product.name,
      talla: selectedSize || null,
      color: selectedColor || null,
      cantidad: quantity,
      precio: applicablePrice.price,
      productPrices: prices,
      image: mainImage,
    };

    if (isIframe) {
      const prev = JSON.parse(localStorage.getItem('carritoPrivado')) || [];

      const existingIndex = prev.findIndex(p =>
        p.productId === item.productId &&
        p.color === item.color &&
        p.talla === item.talla
      );

      if (existingIndex !== -1) {
        prev[existingIndex].cantidad += item.cantidad;
      } else {
        prev.push(item);
      }

      localStorage.setItem('carritoPrivado', JSON.stringify(prev));
      window.dispatchEvent(new Event('cartPrivadoChanged'));

      setAlert({ type: 'info', message: 'Producto añadido al carrito privado' });
    } else {
      // CON LOGIN → flujo normal
      try {
        const body = {
          productId: item.productId,
          quantity: item.cantidad,
          priceSnapshot: item.precio,
          colorSnapshot: item.color,
          sizeSnapshot: item.talla,
        };

        const res = await secureFetch('https://api.minymol.com/cart', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
          body: JSON.stringify(body),
        });

        if (!res.ok) {
          const errorData = await res.json();
          
          // Manejar error de límite de carrito (400)
          if (res.status === 400 && errorData.message?.includes('200')) {
            setAlert({ 
              type: 'error', 
              message: 'Has alcanzado el límite de 200 productos diferentes en el carrito' 
            });
            return;
          }
          
          throw new Error(errorData.message || 'Error al agregar al carrito');
        }

        setAlert({ type: 'info', message: 'Producto agregado' });
      } catch (err) {
        console.error('Error al agregar al carrito:', err);
        
        // Si el error es de autenticación, redirigir a login
        if (err.message?.includes('autenticación') || err.message?.includes('token')) {
          redirectToLogin();
        } else {
          // Mostrar error genérico solo si no se mostró ya
          if (!alert) {
            setAlert({ type: 'error', message: err.message || 'Error al agregar al carrito' });
          }
        }
      }
    }
  };

  // Efecto para price animation
  useEffect(() => {
    const interval = setInterval(() => {
      if (animatedPriceRef.current && applicablePrice?.price) {
        animatedPriceRef.current.locales = 'es-CO';
        animatedPriceRef.current.format = { style: 'decimal' };
        animatedPriceRef.current.update(applicablePrice.price);
        clearInterval(interval);
      }
    }, 50);

    return () => clearInterval(interval);
  }, [applicablePrice]);

  // Intersection Observer para scroll infinito
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (entry.isIntersecting && !loadingProducts && hasMoreProducts && provider) {
          loadProviderProducts(provider.id, selectedCategory, false);
        }
      },
      {
        rootMargin: '100px',
        threshold: 0.1
      }
    );

    const currentObserverTarget = scrollObserverRef.current;
    
    if (currentObserverTarget) {
      observer.observe(currentObserverTarget);
    }

    return () => {
      if (currentObserverTarget) {
        observer.unobserve(currentObserverTarget);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loadingProducts, hasMoreProducts, provider, selectedCategory]);

  if (!id || !product || !provider) {
    return (
      <>
        <Loader />
      </>
    );
  }

  function formatRanges(numbersStr) {
    // Extrae solo los números, sin importar el texto adicional
    const numbers = numbersStr
      .match(/\d+/g) // ← esto extrae todos los números como strings
      ?.map(n => parseInt(n))
      .sort((a, b) => a - b) || [];

    if (numbers.length === 0) return 'Aplica 0 unidades';

    const ranges = [];
    let start = numbers[0];
    let end = numbers[0];

    for (let i = 1; i < numbers.length; i++) {
      if (numbers[i] === end + 1) {
        end = numbers[i];
      } else {
        ranges.push(start === end ? `${start}` : `${start}-${end}`);
        start = numbers[i];
        end = numbers[i];
      }
    }

    ranges.push(start === end ? `${start}` : `${start}-${end}`);
    return `Aplica ${ranges.join(', ')} unidades`;
  }

  return (
    <>

      {alert && (
        <Alert
          type={alert.type}
          message={alert.message}
          onClose={() => setAlert(null)}
        />
      )}

      {!isOrder && <Header searchBar={true} providerBanner={provider.banner_url} />}
      {!isOrder && !isIframe && (
        <div className='product-banner-provider'>
          <button className='btn-back' onClick={() => window.history.back()}>
            <FontAwesomeIcon icon={faChevronLeft} />
          </button>
          <img src={provider.banner_url || '/logoSup.webp'} alt="Banner del proveedor" className='banner-provider' />
        </div>
      )}
      <div className={`product-container ${isOrder ? 'order-cont' : ''}`}>

        <h2 className={`product-title ${isTransitioning ? 'height-transitioning' : ''}`}>{product.name}</h2>
        <div className={`product-image-section ${isTransitioning ? 'height-transitioning' : ''}`}>
          <h2 className={`product-title computadora ${isTransitioning ? 'height-transitioning' : ''}`}>{product.name}</h2>
          <div className='div-computadora'>
            {images.length > 1 && (
              <div className="thumbnail-scroll-wrapper computadora">
                <div className="thumbnail-container">
                  {images.map((img, i) => (
                    <img key={i} src={img.imageUrl} alt={`thumb-${i}`} className={`thumbnail ${mainImage === img.imageUrl ? 'selected' : ''}`} onClick={() => setMainImage(img.imageUrl)} />
                  ))}
                </div>
              </div>
            )}
            <div className="main-image-wrapper" style={{ touchAction: 'auto' }}>
              <img
                ref={mainImageRef}
                src={mainImage}
                alt="Producto"
                className={`main-image ${imgLoaded ? 'loaded' : ''}`}
                onLoad={() => setImgLoaded(true)}
                loading='lazy'
              />
            </div>
            {images.length > 1 && (
              <div className="thumbnail-scroll-wrapper">
                <div className="thumbnail-container">
                  {images.map((img, i) => (
                    <img key={i} src={img.imageUrl} alt={`thumb-${i}`} className={`thumbnail ${mainImage === img.imageUrl ? 'selected' : ''}`} onClick={() => setMainImage(img.imageUrl)} />
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>

        <div className={`product-details ${isTransitioning ? 'height-transitioning' : ''}`}>
          <p className="product-description">{product.description}</p>

          <div className="dynamic-price-highlight">
            <div className="dynamic-price-principal">
              <b className="cop-label">COP</b>
              <number-flow
                ref={animatedPriceRef}
                locales="es-CO"
                className='number-shower'
              ></number-flow>
            </div>
            {!isOrder && !isOwnProduct && (provider.telefono || provider.phone) && (
              <button 
                className="whatsapp-product-btn" 
                onClick={handleWhatsAppContact}
                title="Consultar por WhatsApp"
              >
                <FontAwesomeIcon icon={faWhatsapp} className="whatsapp-product-icon" />
                <div className="whatsapp-product-text">
                  <span className="whatsapp-product-main">Preguntar sobre</span>
                  <span className="whatsapp-product-sub">este producto</span>
                </div>
              </button>
            )}
          </div>

          <p className='p-info-prices'>Este producto tiene descuentos por cantidad. Todos los precios son por unidad.</p>
          <div className="price-scroll-list">
            {prices.map((p, i) => (
              <div key={i} className={`price-block ${p.id === applicablePrice.id ? 'active' : ''}`}>
                <p className="price-amount">COP {parseFloat(p.price).toLocaleString('es-CO')}</p>
                <p className="price-condition">{formatRanges(p.description)}</p>

              </div>
            ))}
          </div>

          <div className="selectors">
            {colors.length > 0 && (
              <div className="unit-selector">
                <label>Color:</label>
                <select name="color" value={selectedColor} onChange={(e) => setSelectedColor(e.target.value)}>
                  <option value="">Selecciona</option>
                  {colors.map((c, i) => <option key={i} value={c.name}>{c.name}</option>)}
                </select>
              </div>
            )}
            {sizes.length > 0 && (
              <div className="unit-selector">
                <label>Talla:</label>
                <select name="size" value={selectedSize} onChange={(e) => setSelectedSize(e.target.value)}>
                  <option value="">Selecciona</option>
                  {sizes.map((s, i) => <option key={i} value={s.name}>{s.name}</option>)}
                </select>
              </div>
            )}
            <div className="quantity-selector">
              <label>Cantidad:</label>
              <select ref={quantityRef} value={quantity} onChange={(e) => setQuantity(parseInt(e.target.value))}>
                {availableQuantities.map(num => (
                  <option key={num} value={num}>{num}</option>
                ))}
              </select>
            </div>
          </div>

          {!isOrder && applicablePrice && (
            <div className="subtotal-container">
              <p className="subtotal-text">
                Subtotal: <strong>COP {(quantity * parseFloat(applicablePrice.price)).toLocaleString('es-CO')}</strong>
              </p>
            </div>
          )}

          {isOrder ? (
            <button className="add-to-cart" onClick={handleAddToOrder}>
              Añadir a la orden
            </button>
          ) : (
            isOwnProduct && (
              <>
                <button
                  className="edit-product-btn"
                  onClick={() => (window.location.href = `/edit-product/${product.id}`)}
                >
                  Editar producto
                </button>
              </>
            )
          )}

          {!isOwnProduct && (
            <button className="add-to-cart" onClick={handleAddToCart}>
              Añadir al carrito
            </button>
          )}

          <div className="line"></div>

          {!isOrder && (
            <>

              <div className="product-provider-info">
                <h1>Información del proveedor</h1>
                <div className='provider-logo'>
                  <img src={provider.logo_url || 'https://cdn.minymol.com/uploads/logoblanco.webp'} alt="Logo del proveedor" />
                  <div>
                    <p className='p-name-provider'>{provider.nombre_empresa}</p>
                    <p className='p-calf-provider'><strong>Calificación: </strong>⭐ {provider.calificacion}</p>
                  </div>
                </div>
                <p className='p-desc-provider'>{provider.descripcion}</p>
                <p className='p-desc-provider'>Cantidad de pedidos: {provider?.cantidadPedidos || 0}</p>
                <p className='p-desc-provider'>Ciudad: {provider?.ciudad || 'Cali'}</p>
              </div>
            </>
          )}

          {!isOrder && relatedProducts.length > 0 && (
            <>
              <div className="line"></div>
              <h2 className="more-products-title">Más productos del proveedor</h2>
              
              {/* Pestañas de categorías/subcategorías */}
              {categories.length > 0 && (
                <div className="category-tabs" style={{
                  display: 'flex',
                  gap: '10px',
                  overflowX: 'auto',
                  padding: '15px 0',
                  marginBottom: '20px',
                  borderBottom: '1px solid #eee'
                }}>
                  <button
                    onClick={() => setSelectedCategory(null)}
                    style={{
                      padding: '8px 16px',
                      border: 'none',
                      borderRadius: '20px',
                      background: !selectedCategory ? '#fa7e17' : '#f5f5f5',
                      color: !selectedCategory ? 'white' : '#333',
                      cursor: 'pointer',
                      whiteSpace: 'nowrap',
                      fontSize: '14px',
                      fontWeight: !selectedCategory ? 'bold' : 'normal',
                      transition: 'all 0.3s'
                    }}
                  >
                    Todos
                  </button>
                  {categories.map((cat) => (
                    <button
                      key={cat.slug}
                      onClick={() => setSelectedCategory(cat.slug)}
                      style={{
                        padding: '8px 16px',
                        border: 'none',
                        borderRadius: '20px',
                        background: selectedCategory === cat.slug ? '#fa7e17' : '#f5f5f5',
                        color: selectedCategory === cat.slug ? 'white' : '#333',
                        cursor: 'pointer',
                        whiteSpace: 'nowrap',
                        fontSize: '14px',
                        fontWeight: selectedCategory === cat.slug ? 'bold' : 'normal',
                        transition: 'all 0.3s'
                      }}
                    >
                      {cat.name} ({cat.productCount})
                    </button>
                  ))}
                </div>
              )}
              
              {/* Grid de productos con scroll infinito */}
              {relatedProducts.length > 0 && (
                <>
                  <Masonry
                    breakpointCols={breakpointColumnsObj}
                    className="products-cont masonry-grid"
                    columnClassName="masonry-grid_column"
                  >
                    {relatedProducts.map((prod, index) => (
                      <ProductWrapper 
                        key={`wrapper-${prod.uuid}-${index}`}
                        product={{...prod, privado: isIframe}} 
                        index={index} 
                      />
                    ))}
                  </Masonry>
                  
                  {/* Trigger para scroll infinito */}
                  {hasMoreProducts && (
                    <div 
                      ref={scrollObserverRef}
                      style={{ 
                        height: '20px',
                        margin: '20px 0',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'
                      }}
                    >
                      {loadingProducts && (
                        <div style={{ 
                          display: 'flex', 
                          alignItems: 'center', 
                          gap: '10px',
                          color: '#666',
                          fontSize: '14px'
                        }}>
                          <div style={{
                            width: '16px',
                            height: '16px',
                            border: '2px solid #f3f3f3',
                            borderTop: '2px solid #3498db',
                            borderRadius: '50%',
                            animation: 'spin 1s linear infinite'
                          }}></div>
                          Cargando más productos...
                        </div>
                      )}
                    </div>
                  )}
                  
                  {/* Indicador de fin */}
                  {!hasMoreProducts && relatedProducts.length > 20 && (
                    <div style={{ 
                      textAlign: 'center', 
                      padding: '20px', 
                      color: '#666',
                      fontSize: '14px'
                    }}>
                      ¡Todos los productos cargados! ({relatedProducts.length} productos)
                    </div>
                  )}
                </>
              )}
            </>
          )}

        </div>
      </div>
      {(!isOrder && !isIframe) && (
        <ShareButton
          title={product.name}
          imageUrl={mainImage}
          redirectUrl={`https://minymol.com/product/${product.id}`}
        />
      )}
      {isIframe && (
        <a
          href="/carrito-privado"
          className={`floating-cart-btn ${hasItems ? 'pulse' : ''}`}
        >
          <FontAwesomeIcon icon={faShoppingCart} />
        </a>
      )}
      {(!isOrder && !isIframe) && <NavInf isProductInfo={true} />}
      {(!isOrder && !isIframe) && <Footer />}
    </>
  );
};

export default ProductInfo;
